const CartIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0.5H2.058C2.754 0.5 3.102 0.5 3.364 0.689C3.626 0.878 3.736 1.208 3.956 1.868L4.5 3.5"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M14.4998 13.5H5.04984C4.90484 13.5 4.83184 13.5 4.77584 13.494C4.63699 13.4785 4.50293 13.4341 4.3823 13.3636C4.26167 13.2932 4.15714 13.1982 4.07545 13.0848C3.99377 12.9715 3.93674 12.8423 3.90804 12.7056C3.87935 12.5688 3.87962 12.4276 3.90884 12.291C3.93183 12.2025 3.95886 12.1151 3.98984 12.029C4.04184 11.875 4.06684 11.798 4.09584 11.729C4.23819 11.388 4.4722 11.0932 4.77193 10.8771C5.07165 10.6611 5.42537 10.5323 5.79384 10.505C5.86784 10.5 5.94884 10.5 6.11084 10.5H11.4998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1791 10.5H8.1381C6.8581 10.5 6.2181 10.5 5.7181 10.17C5.2171 9.84 4.9651 9.252 4.4611 8.076L4.2921 7.682C3.4821 5.792 3.0781 4.849 3.5221 4.174C3.9681 3.5 4.9961 3.5 7.0501 3.5H12.3301C14.6301 3.5 15.7791 3.5 16.2131 4.247C16.6461 4.994 16.0761 5.992 14.9351 7.988L14.6521 8.485C14.0901 9.468 13.8091 9.96 13.3431 10.23C12.8771 10.5 12.3111 10.5 11.1791 10.5Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M14 17C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15C13.4477 15 13 15.4477 13 16C13 16.5523 13.4477 17 14 17Z"
        fill="currentColor"
      />
      <path
        d="M6 17C6.55228 17 7 16.5523 7 16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CartIcon;
